import Matrix from "algorithm/matrix";
import { unilateralAlloc } from "algorithm/unilateralAlloc";
import Vector from "algorithm/vector";
import { Allocations, TrancheProfile } from ".";
import { cumulatizeTrancheProfile } from "./trancheUtils";

export function tranchifiedUnilateralAlloc(
  trancheProfile: TrancheProfile,
  budget: number,
  holdProposalId: string,
): Allocations {
  const cumulativeTrancheProfile = cumulatizeTrancheProfile(trancheProfile);
  const evaluableIds = [
    ...new Set(
      cumulativeTrancheProfile.flatMap((t) => Object.keys(t.allocations)),
    ),
  ];

  const plist = cumulativeTrancheProfile.map((tranche) =>
    evaluableIds.map((id) => tranche.allocations[id]?.amount ?? 0),
  );

  let holdProposalIndex = evaluableIds.indexOf(holdProposalId);
  if (holdProposalIndex === -1) {
    evaluableIds.unshift(holdProposalId);
    holdProposalIndex = 0;
    // throw new Error(
    //   "Tried running S-Process without a hold, this should not be possible",
    // );
  }

  const lastRow = [...plist[plist.length - 1]];
  lastRow[holdProposalIndex] = budget;
  plist.push(lastRow);

  const alloc = unilateralAlloc(new Matrix(plist), budget);

  return mapAmountsToAllocations(alloc, evaluableIds);
}

function mapAmountsToAllocations<A extends string>(
  amounts: Vector<A>,
  evaluableIds: string[],
): Allocations {
  const allocations: Allocations = {};
  for (let i = 0; i < evaluableIds.length; i++) {
    allocations[evaluableIds[i]] = {
      amount: amounts.get(i),
      bottomPlaced: false,
    };
  }
  return allocations;
}
